import HijackButton from './HijackButton'

export default function install(Vue) {
  Vue.component('hijack-button', HijackButton)
}
